import Vue from 'vue';
import Vuex from 'vuex';
import { getSeriesList,getSeriesInfo,getSeriesColor,choseProduct,addShopCart } from '@/api/series'
Vue.use(Vuex);

const state = {
    seriesList:[],
    seriesInfo:{},
    seriesColor:[]
}
const mutations = {
    setSeriesList: (state,seriesList)=>{

        state.seriesList = seriesList
    },
    setSeriesInfo: (state,seriesInfo)=>{
        state.seriesInfo = seriesInfo
    },
    setSeriesColor: (state,seriesColor)=>{
        state.seriesColor = seriesColor
    }
}
const actions = {
    SERIESLIST({ commit }) {
        return new Promise((resolve, reject) => {
            getSeriesList().then(response => {
                if (response.code) {
                    commit('setSeriesList', response.data);
                    resolve(response)
                } else {
                    reject(response.msg)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },
    SERIESINFO({commit},id){
        return new Promise((resolve, reject) => {
            getSeriesInfo(id).then(response => {
                if (response.code) {
                    response.data.cart.color.map((item)=>{
                        item.status = true
                    })
                    commit('setSeriesInfo', response.data);
                    resolve(response)
                } else {
                    reject(response.msg)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },
    // 系列下的颜色详情
    SERIESCOLOR({commit},data){
        return new Promise((resolve, reject) => {
            getSeriesColor(data).then(response => {
                if (response.code) {
                    commit('setSeriesColor', response.data);
                    resolve(response)
                } else {
                    reject(response.msg)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },
    // 产品选择
    CHOSEPRODUCT({},_data){
        return new Promise((resolve, reject) => {
            choseProduct(_data).then(response => {
                if (response && response.code === 200)
                    resolve(response);
            })
        })
    },
    // 添加购物车
    ADDSHOPCART({},data){
        return new Promise((resolve, reject) => {
            addShopCart(data).then(response => {
                if (response && response.code === 200)
                    resolve(response);
            })
        })
    }
}
const getters = {

}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}